import { MenuItem } from './menu.item.model';

export interface SupervisorMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: SupervisorMenuSection[] = [
  {
    title: 'nav-item.operational.home',
    items: [
      { icon: 'home', name: 'nav.home', route: '/home' },
    ],
  },
  {
    title: 'nav-item.operational.title',
    items: [
      { icon: 'business', name: 'nav.sites', route: '/worker/sites' },
      { icon: 'layers', name: 'nav.projects', route: '/projects' },
      { icon: 'document', name: 'sites.tickets', route: '/manager/tasks' },
    ],
  },
  {
    title: 'nav-item.sales.title',
    items: [
      { icon: 'albums', name: 'nav.clients', route: '/clients' },
      { icon: 'cash', name: 'nav.sales', route: '/contractors/sales' },
    ],
  },
  {
    title: 'nav-item.reporting.title',
    items: [
      { icon: 'analytics', name: 'nav.reports', route: '/workforce-v2/customer-approvals' },
    ],
  },
  {
    title: 'nav-item.system.title',
    items: [
      { icon: 'cog', name: 'nav.extras', route: '/options' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      { icon: 'help-circle-outline', name: 'nav-item.support.help', route: '/support' },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const supervisorMenu = {
  sections,
  items,
};
